export default {
    NONE: 'NONE',
    LEFT_PANEL: 'LEFT_PANEL',
    RIGHT_PANEL: 'RIGHT_PANEL',
} as const;
